<template>
    <div class="seo w-100 d-inline-block mt-4">
        <div :class="{
                'input-focus-effect': true,
                'rv-valiadate-input-form': error
            }">
            <input :class="seo != '' ? 'border-primary' : ''" type="text" id="inputTitle"
                v-model="seo" @focus="$emit('update:error', '')"/>
            <label :class="{
                    'mb-0': true,
                    'input-on-alue': seo != ''
                }">Từ khóa SEO (VD: điện thoại, Máy tính,...)</label>
        </div>
        <div class="text-danger fs-12px mt-1" v-if="error">{{error}}</div>
    </div>
</template>
<script>
export default {
    props: ['data', 'error'],
    data() {
        return {
            seo: ''
        }
    },
    watch: {
        data(val){
            this.seo = val;
        },
        seo(val){
            this.$emit('update:data', val);
        }
    },
    created() {
        this.seo = this.data;
    }
}
</script>
